import { useDispatch, useSelector } from "react-redux";
import showToast from "../../Hooks/toast";
import { useLazyGetTechniciansForMonthQuery } from "../../../Store/Builder/schedule.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import {
  setAllDays,
  setDisabledDates,
  setTechnicianLocations,
} from "../../../Store/Slice/scheduleSlice";

const useGetTechniciansForMonth = () => {
  const dispatch = useDispatch();
  const [getTechnicians] = useLazyGetTechniciansForMonthQuery();
  const { lat, lon } = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const durationMinutes = useSelector((state) => state.rootReducer.scheduleSlice.total_time);
  const radius = useSelector((state) => state.rootReducer.scheduleSlice.radius);
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const lineItems = useSelector((state) => state.rootReducer.scheduleSlice.line_items);

  const get = (year, month, duration, product_ids) => {
    dispatch(setLoader(true));
    const params = {
      lat,
      lon,
      durationMinutes: duration || durationMinutes,
      year,
      month,
      radius,
      job_except: +activeJob?.id,
      product_ids: product_ids || lineItems?.map(item => item?.product?.value),
    };
    const valid = Object.values(params).every((value) => !!value);
    if (!valid && +activeJob?.id) {
      showToast("Enter your address first", "error");
      dispatch(setLoader(false));
      return;
    }
    getTechnicians(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        let data = [...res?.weeks];
        let disabledDates = [];

        data = data?.map((item, index) => {
          let sItem = JSON.parse(JSON.stringify(item));
          for (let key in item) {
            const { day, active } = item[key];
            if (day !== "" && !active) {
              const newDate = new Date(year, Number(month) - 1, Number(day));
              disabledDates.push(newDate.toISOString());
              if (Array.isArray(sItem[key]?.date)) {
                sItem[key].date = [...sItem[key].date, newDate.toISOString()];
              } else {
                sItem[key].date = [newDate.toISOString()];
              }
            }
          }
          return sItem;
        });
        dispatch(setAllDays(data));
        dispatch(setDisabledDates(disabledDates));
        dispatch(setTechnicianLocations(res?.technicianLocations));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  };

  return {
    get,
  };
};

export default useGetTechniciansForMonth;
